module.exports = __webpack_public_path__ + "static/assets/7fab4344ee6c8c4dbc448efba64cb49a.png";